export { firebaseConfig, getFirebaseApp, isFirebaseConfigured } from './config';
export { signInWithGoogle } from './auth';

export const analyticsEvents = {
  login: (_method: string) => {},
  signUp: (_method: string) => {},
  logout: () => {},
};
